export default __webpack_public_path__ + "8f1159b3dda376c1b0dc58fa3ea6a5dc.svg";